export const DisplayState = {
    Abstract: 0,
    AcademicBackground: 1,
    Awards: 2,
    Conferences: 3,
    Journals: 4,
    Contact: 5,
};